import { BTMenu } from "@btnet/core-components/BTMenu";

import { BTIconListBullets } from "commonComponents/btWrappers/BTIcon";
import { isSelectionExclusivelyInTitle } from "commonComponents/btWrappers/editor/core/editor.utils";
import { type ICollapsableControl } from "commonComponents/btWrappers/editor/core/EditorControlBar/common/CollapsableControlGroup/CollapsableControlGroup";
import { EditorControlButton } from "commonComponents/btWrappers/editor/core/EditorControlBar/common/EditorControlButton/EditorControlButton";
import { InputRecaptureHackMenuItem } from "commonComponents/btWrappers/editor/core/EditorControlBar/common/InputRecaptureHack/InputRecaptureHack";
import { type ExtensionName } from "commonComponents/btWrappers/editor/core/extensions/editorExtensionUtils";
import { type IEditor } from "commonComponents/btWrappers/editor/core/useBTEditor.types";

const extensionId = "bulletList";
const friendlyName = "Bullet List";
const icon = <BTIconListBullets />;
const onClick = (editor: IEditor) => {
    return editor.tiptapEditor.chain().focus().toggleBulletList().run();
};

export const bulletListControl: ICollapsableControl = {
    key: extensionId,
    isControlSupported(supportedExtensions: Set<ExtensionName>, editor: IEditor) {
        return (
            supportedExtensions.has("listItem") &&
            supportedExtensions.has(extensionId) &&
            editor.editorState.mode !== "inlineControlsOnly"
        );
    },
    isControlEnabled({ tiptapEditor }) {
        return (
            // can replace the isSelectionExclusiveleyInTitle with the line below when https://github.com/ueberdosis/tiptap/issues/3229
            // is resolved
            // tiptapEditor.chain().focus().toggleBulletList().run() &&
            !isSelectionExclusivelyInTitle(tiptapEditor, tiptapEditor.state.selection)
        );
    },
    expandedElement(editor) {
        return (
            <EditorControlButton
                friendlyName={friendlyName}
                data-testid="bulletListControl"
                icon={icon}
                isToggled={editor.tiptapEditor.isActive(extensionId)}
                onClick={() => onClick(editor)}
                disabled={!this.isControlEnabled(editor)}
            />
        );
    },
    collapsedActiveKeys({ tiptapEditor }) {
        return tiptapEditor.isActive(extensionId) ? [extensionId] : [];
    },
    collapsedMenuItem(editor) {
        return (
            <InputRecaptureHackMenuItem
                editor={editor}
                menuComponent={BTMenu.Item}
                menuProps={{
                    testid: this.key,
                    onClick: () => onClick(editor),
                    className: "btEditorControlBarMenuItem",
                    icon: icon,
                    disabled: !this.isControlEnabled(editor),
                }}
                key={this.key}
            >
                {friendlyName}
            </InputRecaptureHackMenuItem>
        );
    },
};
export default bulletListControl;
